export const BACKEND_DATE_FORMAT = "DD-MM-YYYY";
export const BACKEND_DATETIME_FORMAT = "DD-MM-YYYY HH:mm:ss.SSS";
export const GET_MORE_MESSAGES_AMOUNT = 10;
export const CHAT_SYSTEM_MESSAGE_SENDER = "noreply@vaidevan.app";
export const MINUTES_BEFORE_RESERVATION_DEADLINE_TO_SHOW_WARNING = 30;
